module.exports = __webpack_public_path__ + "static/img/title.0e575e6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/page/title.gif
// module id = fdV4
// module chunks = 1